import React from "react"
import styled from "@emotion/styled"


const Container = styled.div`
  display: flex;
  font-size: 12px;
  line-height: 16px;
  background-color: #525050;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
`

const WrapperOffices = styled.div`
  display: flex;
  max-width: 1200px;
  width: 100%;
  @media (max-width: 1199px) {
    max-width: 600px;
    flex-direction: row;
    flex-wrap: wrap;
  }
  @media (max-width: 599px) {
    max-width: 300px;
  }
`

const Office = styled.div`
  width: 300px;
  display: flex;
  text-align: center;
  padding-bottom: 1rem;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid #6a6a6a;
  padding-top: 10px;

  @media (min-width: 1200px) {
    :last-child {
      border: 0;
    }
  }

  @media (max-width: 1199px) {
    border-right: 0;
    :nth-of-type(1) {
      border-right: 1px solid #6a6a6a;
    }
    :nth-of-type(3) {
      border-right: 1px solid #6a6a6a;
      border-top: 1px solid #6a6a6a;
    }
    :nth-of-type(4) {
      border-top: 1px solid #6a6a6a;
    }
  }

  @media (max-width: 599px) {
    :nth-of-type(n) {
      border-right: 0;
      border-top: 0;
      border-bottom: 1px solid #6a6a6a;
    }
    :last-child {
      border-bottom: 0;
    }
  }
`

const City = styled.h3`
  text-align: center;
  font-family: Inter;
  color: #ffffff;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 4.5px;
  cursor: pointer;
`

const Field = styled.span`
  min-width: 240px;
  display: block;
  color: #cccccc;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
  cursor: pointer;
`

const Telephone = styled.a`
  text-decoration: none;
  color: #cccccc;
  font-weight: 700;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  text-decoration: none;
  color: #cccccc;
  font-weight: 700;
  line-height: 24.4px;
  cursor: pointer;
`

const ChileFlagImage = styled.img`
  width: 30px;
  height: 30px;
`

const PeruFlagImage = styled.img`
  width: 30px;
  height: 30px;
`

const UruguayFlagImage = styled.img`
  width: 30px;
  height: 30px;
`

const MexicoFlagImage = styled.img`
  width: 30px;
  height: 30px;
`

export const openInNewTab = (url: string): void => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer")
  if (newWindow) newWindow.opener = null
}

export const onClickUrl = (url: string): (() => void) => () => openInNewTab(url)

const LIST_OFFICES = [
  {
    flag: <ChileFlagImage src="/chile-flag.png" alt="Chile Flag" />,
    street: "Av. Vitacura 3565, Oficina 101",
    city: "Santiago",
    region: "Vitacura",
    phone: "+56 2 2592 6600",
    url: "https://maps.app.goo.gl/Uc71RBbQ7mw8nkdUA",
  },
  {
    flag: <PeruFlagImage src="/peru-flag.png" alt="Peru Flag" />,
    street: "Víctor Andrés Belaúnde 147",
    city: "Lima",
    region: "Torre Real 2, San Isidro",
    phone: "+51 944 737 651",
    url: "https://maps.app.goo.gl/GuZ8jbnGvxtxvxVi6",
  },
  {
    flag: <UruguayFlagImage src="/uruguay-flag.png" alt="Uruguay Flag" />,
    street: <>Dr. Luis Alberto de Herrera 1248 <br />Torre 3 piso 12</>,
    city: "Montevideo",
    region: "",
    phone: "+598 95 505 694",
    url: "https://maps.app.goo.gl/d9dJ69eRjXkM1Nt3A",
  },
  {
    flag: <MexicoFlagImage src="/mexico-flag.png" alt="Mexico Flag" />,
    street: <>Torre Reforma / Piso 14 Reforma #483, Cuauhtemoc</>,
    city: "CDMX",
    region: "Mexico",
    phone: "+52 55 4947 3878",
    url: "https://maps.app.goo.gl/D2DeD9NH3RjZWK9Q6",
  },
]

const Offices = () => (
  <>
    <Container>
      <WrapperOffices>
        {LIST_OFFICES.map((office, idx) => (
          <Office
            key={`office-${idx}`}
          >
            {office.flag}
            <City>{office.city}</City>
            <Field onClick={onClickUrl(office.url)}>{office.street}</Field>
            <Field onClick={onClickUrl(office.url)}>{office.region}</Field>
            <Telephone onClick={onClickUrl(`tel:${office.phone}`)}>{office.phone}</Telephone>
          </Office>
        ))}
      </WrapperOffices>
    </Container>
  </>
)


export default Offices
